export const MB_RATIO = 1048576;
export const MB_COUNT = 300;
export const MAX_FILES_SIZE = MB_COUNT * MB_RATIO;
export const filesExtensions = [
  'xlsx',
  'xls',
  'jpg',
  'png',
  'jpeg',
  'pdf',
  'doc',
  'docx',
  'txt',
  'mp4',
  'webp',
  // MOV — видео с iPhone, DNG — RAW-снимок (us/11171). Только фильтр
  // загрузки: превью чата их не рисует, они попадают в общий список
  // вложений как документы.
  'mov',
  'dng',
];
